import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../../@fuse/services/translation-loader.service";
import {WorkTimeService} from "../../../workTime/service/workTime.service";
import {first} from "rxjs/operators";
import {WorkTimeSummaryList} from "../../../workTime/model/workTimeSummaryList";


@Component({
    selector: 'work-time-report-dialog',
    templateUrl: './workTimeReportDialog.component.html',
    styleUrls: ['./workTimeReportDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class WorkTimeReportDialogComponent {
    action: string;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    editMode: boolean = false;
    fromDate: string = '';
    toDate: string = '';
    userId: string;
    workTimeSummaryList: WorkTimeSummaryList = {items: []};
    loading: boolean = false;
    locale = 'pl';

    constructor(
        public matDialogRef: MatDialogRef<WorkTimeReportDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        private workTimeService: WorkTimeService,
        public _matDialog: MatDialog,
    ) {
        this.userId = _data.userId;
        this.fromDate = _data.fromDate;
        this.toDate = _data.toDate;
        this.translationLoader.loadTranslations(polish);

        this.loading = true;
        this.workTimeService.getByUserIdAndTimeSpan(this.userId, this.fromDate, this.toDate).pipe(first()).subscribe((res: WorkTimeSummaryList) => {
            this.workTimeSummaryList = res;
            this.loading = false;
        });
    }
}
